// extracted by mini-css-extract-plugin
export default {"ant-page-header":"styles_ant-page-header__SzakE","ant-page-header-heading-title":"styles_ant-page-header-heading-title__luCbx","table":"styles_table__erytR"};